/* Azar Group — menu cards (snippets/azar-drawer-cards.liquid)

   The swipe itself is CSS scroll-snap. This only keeps the dots in step with
   the card on screen and lets a dot be tapped to jump, so with the script
   blocked the deck still works, it just loses the dots' highlight. */

(function () {
  document.querySelectorAll('[data-azar-cards]').forEach(init);

  function init(deck) {
    if (deck.dataset.azarCardsInit === 'true') return;
    deck.dataset.azarCardsInit = 'true';

    var track = deck.querySelector('[data-azar-cards-track]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-azar-card]'));
    var dots = Array.prototype.slice.call(deck.querySelectorAll('[data-azar-dot]'));
    if (cards.length < 2 || dots.length === 0) return;

    /* The card whose middle is nearest the middle of the viewport wins, so a
       half-swipe that snaps back does not leave the wrong dot lit. */
    function current() {
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var shortest = Infinity;
      cards.forEach(function (card, i) {
        var mid = card.offsetLeft - cards[0].offsetLeft + card.offsetWidth / 2;
        var gap = Math.abs(mid - centre);
        if (gap < shortest) {
          shortest = gap;
          best = i;
        }
      });
      return best;
    }

    function sync() {
      var index = current();
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    var idle = null;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(idle);
        idle = setTimeout(sync, 60);
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({
          left: cards[i].offsetLeft - cards[0].offsetLeft,
          behavior: reduced ? 'auto' : 'smooth'
        });
      });
    });

    sync();
  }
})();
